<template>
  <div class="stepper">
    <p v-if="isSmallScreen">
      STEP <span>{{ step }}</span> of 5
    </p>
    <ul v-else>
      <li v-for="n in 5" :key="`step-${n}`">
        <span class="number" :class="{ active: props.step === n, done: props.step > n }">{{ n }}</span>
        <span class="name" :class="{ active: props.step === n }">{{ STEPS[n].name }}</span>
      </li>
    </ul>
  </div>
</template>


<script setup>
import { ref, computed, onMounted, onUnmounted } from 'vue';
import { useStore } from 'vuex';

// Props
const props = defineProps({
  step: {
    type: Number,
    required: true,
  },
});

// Reactive refs and store
const isSmallScreen = ref(false);
const store = useStore();

// computed props
const STEPS = computed(() => store.state.user.STEPS);

const onResize = () => {
  isSmallScreen.value = window.innerWidth <= 610;
};

// Lifecycle hooks 
onMounted(() => {
  onResize(); 
  window.addEventListener('resize', onResize);
});

onUnmounted(() => {
  window.removeEventListener('resize', onResize);
});
</script>


<style scoped lang="scss">
.stepper {
  background-color: var(--ri-light-gray);
  @extend %global-side-padding;
  p {
    @extend %font-serif-regular;  // media query cannot do @extend
    font-size: 1.15rem;
    font-weight: 700;
    padding: 0.5em 0;
    span {
      color: var(--ri-orange);
    }
  }
  ul {
    @extend %flex-row-space-between;
    padding: 1.25em 0;
    li {
      @extend %flex-row-space-between;
      font-size: 0.875rem;
      text-align: center;
      .number {
        background-color: var(--ri-light-blue);
        border-radius: 16px;
        @extend %font-sans-bold;
        font-size: 1rem;
        padding: 0.4em 0.7em;
        height: 32px;
        width: 32px;
        &.active {
          background-color: orange;
        }
        &.done {
          background-color: var(--ri-gray);
        }
      }
      .name {
        margin-left: 0.75em;
        margin-right: 0.75em;
        &.active {
          @extend %font-sans-bold;
        }
      }
    }
  }
  @media print {
    display: none;
  }
}
@media only screen and (max-width: 1200px) {
  .stepper {
    li {
      flex-direction: column;
      .name {
        margin-top: 0.5em;
      }
    }
  }
}
</style>
